import { useEffect, useState } from "react";
import { getSimpleAddress } from "../common/helper";
import { AllowanceService } from "../openapi";
import dateFormat from "dateformat";
import { useNavigate } from "react-router-dom";

type Props = {
  apy: number;
};

export const RecentAllowanceCard = ({ apy }: Props) => {
  const navigate = useNavigate();

  const [allowance, setAllowance] = useState<any[]>([]);

  useEffect(() => {
    AllowanceService.listAllowances(apy, 0, 5)
      .then((res) => {
        setAllowance(res[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [apy]);

  return (
    <div className="col-span-12 xxl:col-span-4">
      <div className="box overflow-hidden">
        <div className="box-header">
          <div className="sm:flex justify-between space-y-2 sm:space-y-0">
            <h5 className="box-title my-auto">
              Recent Allowance ( APY : {apy} )
            </h5>
            <div className="block ltr:ml-auto rtl:mr-auto my-auto">
              <button
                type="button"
                className="ti-btn m-0 rounded-sm p-1 px-3 !border border-gray-200 text-gray-400 hover:text-gray-500 hover:bg-gray-200 hover:border-gray-200 focus:ring-gray-200  dark:hover:bg-black/30 dark:border-white/10 dark:hover:border-white/20 dark:focus:ring-white/10 dark:focus:ring-offset-white/10"
                onClick={() => navigate("/allowance/" + apy)}
              >
                View All
              </button>
            </div>
          </div>
        </div>
        <div className="box-body p-0 activity-table">
          <div className="overflow-auto">
            <table className="ti-custom-table ti-custom-table-head">
              <thead className="">
                <tr>
                  <th scope="col" className="min-w-[200px]">
                    Address
                  </th>
                  <th scope="col text-center">Created At</th>
                </tr>
              </thead>
              <tbody>
                {allowance.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td className="text-center">
                        {getSimpleAddress(item.account, 8)}
                      </td>
                      <td className="text-center">
                        {dateFormat(item.createdAt, "yyyy-mm-dd HH:MM:ss")}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
